export const plural = (count: number) => (count === 1 ? '' : 's');
